/* Art Driver — minimal vanilla JS.
   Nav solid-on-scroll + full-screen hamburger menu overlay.
   Translates 1:1 to a Shopify theme (theme.liquid / header assets). */

(function () {
  /* ---------- Hero video — coax iOS into autoplay; retry on first touch ---------- */
  var heroVideo = document.querySelector(".hero__video");
  if (heroVideo) {
    heroVideo.muted = true;
    var adPlayHero = function () { var p = heroVideo.play(); if (p && p.catch) p.catch(function () {}); };
    adPlayHero();
    heroVideo.addEventListener("loadeddata", adPlayHero);   // retry once the first frames are decoded
    heroVideo.addEventListener("canplay", adPlayHero);
    document.addEventListener("touchstart", function adHeroOnce() {
      adPlayHero();
      document.removeEventListener("touchstart", adHeroOnce);
    }, { passive: true });
  }

  /* ---------- Smooth scroll (Lenis), like vaonis.com ---------- */
  var lenis = null;
  if (window.Lenis) {
    lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    var raf = function (time) { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);

    // In-page anchor links scroll smoothly, offset for the fixed navbar
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var href = a.getAttribute("href");
        if (href.length > 1) {
          var el = document.querySelector(href);
          if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -80 }); }
        }
      });
    });
  }

  var nav = document.getElementById("nav");
  var menu = document.getElementById("menu");
  var openBtn = document.getElementById("navToggle");
  var closeBtn = document.getElementById("menuClose");

  // Navbar reveal:
  //  - Homepage (has a full hero): hidden on load, slides in on first scroll and stays.
  //  - Inner pages (no hero): visible from the start.
  if (nav) {
    if (document.querySelector(".hero")) {
      var revealed = false;
      var onScroll = function () {
        if (!revealed && window.scrollY > 80) {
          nav.classList.add("is-visible");
          revealed = true;
        }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    } else {
      nav.classList.add("is-visible");
    }
  }

  function openMenu() {
    menu.classList.add("is-open");
    document.body.classList.add("menu-locked");
    openBtn.setAttribute("aria-expanded", "true");
    if (lenis) lenis.stop();
  }
  function closeMenu() {
    menu.classList.remove("is-open");
    document.body.classList.remove("menu-locked");
    openBtn.setAttribute("aria-expanded", "false");
    if (lenis) lenis.start();
  }

  if (openBtn && menu) {
    openBtn.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeMenu();
    });
  }

  /* ---------- Infinite carousel (arrows + drag + trackpad swipe) ----------
     Reused by The Shop (multi-card) and the Pro Team slider (one panel/view). */
  function initCarousel(track, prevBtn, nextBtn) {
    if (!track) return;

    var base = Array.prototype.slice.call(track.children);
    var baseCount = base.length;
    if (!baseCount) return;

    // Clone the full set before and after → seamless wrap in both directions
    var pre = document.createDocumentFragment();
    var post = document.createDocumentFragment();
    base.forEach(function (c) { pre.appendChild(c.cloneNode(true)); });
    base.forEach(function (c) { post.appendChild(c.cloneNode(true)); });
    track.insertBefore(pre, track.firstChild);
    track.appendChild(post);

    var viewport = track.parentElement;
    var step = 0, setWidth = 0, pos = 0;   // pos = continuous translateX (free, no snap)
    var dragging = false, down = false, startX = 0, moved = 0;

    function measure() {
      var kids = track.children;
      step = kids[1].getBoundingClientRect().left - kids[0].getBoundingClientRect().left;
      setWidth = step * baseCount;
    }
    function wrap() {                       // keep pos inside the cloned middle range (invisible jump)
      if (!setWidth) return;
      while (pos <= -2 * setWidth) pos += setWidth;
      while (pos > -setWidth) pos -= setWidth;
    }
    function render(animate, delta) {
      track.style.transition = animate ? "transform .55s cubic-bezier(.22,.61,.36,1)" : "none";
      track.style.transform = "translate3d(" + (pos + (delta || 0)) + "px,0,0)";
    }
    track.addEventListener("transitionend", function () {
      var before = pos; wrap();
      if (pos !== before) render(false);
    });

    // Arrows still advance one card; drag/swipe are free (land exactly where you stop)
    if (nextBtn) nextBtn.addEventListener("click", function () { pos -= step; render(true); });
    if (prevBtn) prevBtn.addEventListener("click", function () { pos += step; render(true); });

    track.addEventListener("pointerdown", function (e) {
      down = true; dragging = false; startX = e.clientX; moved = 0;
    });
    track.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 5) {    // only become a drag past a small threshold
        dragging = true;
        track.style.transition = "none";
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (dragging) { moved = dx; render(false, moved); }
    });
    function endDrag() {
      if (!down) return;
      down = false;
      if (dragging) { pos += moved; wrap(); render(false); }   // a real drag — land where released
      dragging = false;                                         // a clean click falls through → link navigates
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);

    // Suppress the click that follows a real drag (so links don't fire)
    track.addEventListener("click", function (e) {
      if (Math.abs(moved) > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // Trackpad two-finger horizontal swipe (and shift+wheel) — free, no snap
    viewport.addEventListener("wheel", function (e) {
      var dx = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (!dx || !step) return;            // vertical scroll → let the page scroll
      e.preventDefault();
      e.stopPropagation();                 // keep Lenis from also reacting
      pos -= dx; wrap(); render(false);    // stays exactly where you stop
    }, { passive: false });

    var lastW = window.innerWidth;
    function reset() { measure(); pos = -setWidth; wrap(); render(false); }
    window.addEventListener("resize", function () {
      var w = window.innerWidth;
      if (w === lastW) { measure(); wrap(); render(false); return; }  // iOS address bar (height-only) — keep position
      lastW = w;                                                       // real width change (orientation) — full reset
      reset();
    });
    window.addEventListener("load", reset);
    reset();
  }

  initCarousel(
    document.getElementById("shopTrack"),
    document.querySelector(".shop__arrow--prev"),
    document.querySelector(".shop__arrow--next")
  );

  /* ---------- Product page — live variant price + availability ---------- */
  (function () {
    var sel = document.getElementById("pdpVariant");
    var dataEl = document.getElementById("pdpVariants");
    if (!sel || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var priceEl = document.getElementById("pdpPrice");
    var noteEl = document.getElementById("pdpNote");
    var btn = document.getElementById("pdpAdd");
    function update() {
      var v = null;
      for (var i = 0; i < data.length; i++) {
        if (String(data[i].id) === String(sel.value)) { v = data[i]; break; }
      }
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      var mainImg = document.getElementById("pdpMain");
      if (mainImg && v.img) mainImg.src = v.img;   // swap product photo to the selected color
      if (v.available) {
        if (btn) { btn.disabled = false; btn.textContent = "Add to cart"; }
        if (noteEl) noteEl.hidden = true;
      } else {
        if (btn) { btn.disabled = true; btn.textContent = "Sold out"; }
        if (noteEl) noteEl.hidden = false;
      }
    }
    sel.addEventListener("change", update);
    update();
  })();

  /* ---------- Scroll reveal — subtle, one-time, no library ---------- */
  (function () {
    if (!("IntersectionObserver" in window)) return;   // older browsers: content stays visible
    var targets = document.querySelectorAll(
      ".nexo-feature, .shop__head, .team__head, .team__grid .tm, .pdp-info__head, .pdp-hi, .pdp-info__cols"
    );
    if (!targets.length) return;
    document.documentElement.classList.add("has-reveal");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    targets.forEach(function (el) { el.classList.add("reveal"); io.observe(el); });
  })();
})();
